import styled from '@emotion/styled/macro';
import { Variables } from '../../../base';

export const CdPanel = styled.div<{ $embedded?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: ${({ $embedded }) => ($embedded ? '12px' : '16px')};
    width: 100%;
    min-width: 0;
`;

export const CdCard = styled.section<{ $embedded?: boolean }>`
    background: ${Variables.ThemeLight.Background3};
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: ${({ $embedded }) => ($embedded ? '10px' : '12px')};
    box-shadow: ${({ $embedded }) => ($embedded ? Variables.Shadows.border : Variables.Shadows.small)};
`;

export const CdSectionCard = styled(CdCard)`
    padding: 18px 22px 20px;
`;

export const CdSectionTitle = styled.h2`
    margin: 0 0 14px;
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMedium};
`;

export const CdFactsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px 28px;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const CdFactCell = styled.div<{ $span?: number }>`
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    grid-column: ${({ $span }) => ($span ? `span ${$span}` : 'auto')};
`;

export const CdFactLabel = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 9px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextXMild};
`;

export const CdFactValue = styled.span<{ $mono?: boolean }>`
    font-family: ${Variables.Fonts.calibre};
    font-size: 14px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextStrong};
    text-wrap: pretty;
    word-break: ${({ $mono }) => ($mono ? 'break-all' : 'normal')};
    font-variant-numeric: ${({ $mono }) => ($mono ? 'tabular-nums' : 'normal')};
`;

export const CdFactMuted = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 14px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextXMild};
    font-style: italic;
`;
